module.exports = __webpack_public_path__ + "img/hp-two-3.bee5d98d.jpg";